import React, {
  useState,
  ChangeEvent,
} from 'react';
import { FieldProps } from 'formik';
import classnames from 'classnames';
import { EyeIcon } from '../../../icons';

import styles from './PasswordField.module.scss';

export type PasswordFieldProps<T> = FieldProps<T> & BasicFieldProps;

function PasswordField<T extends string | number | undefined>({
  field: {
    value,
    name,
    checked,
    onChange,
    onBlur,
  },
  form,
  className,
  label,
  disabled = false,
}: PasswordFieldProps<T>): JSX.Element {
  const [fieldFocus, setFieldFocus] = useState(false);
  function handleFocus() {
    setFieldFocus(true);
  }

  function handleBlur(e: ChangeEvent<HTMLInputElement>) {
    setFieldFocus(false);
    onBlur(e);
  }

  const [visible, setVisible] = useState(false);
  function handleEye() {
    setVisible(!visible);
  }

  const valid = (form?.touched?.[name] || false) && !(form?.errors?.[name] || false);
  const invalid = (form?.touched?.[name] || false) && (form?.errors?.[name] || false);

  return (
    <div className={classnames(
      className,
      styles.passwordFieldContainer,
    )}
    >
      <div
        data-testid={`password-field-${name}`}
        className={classnames(styles.passwordField, {
          [styles.passwordFieldFocus]: fieldFocus,
          [styles.passwordFieldDisabled]: disabled,
          [styles.passwordFieldValid]: valid,
          [styles.passwordFieldInvalid]: invalid,
        })}
      >

        <input
          id={name}
          type={visible ? 'text' : 'password'}
          value={value}
          name={name}
          className={styles.passwordFieldInput}
          checked={checked}
          onChange={onChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          disabled={disabled}
        />
        {label && (
          <label htmlFor={name}>
            {label}
          </label>
        )}
        <button
          type="button"
          className={styles.visibleEye}
          onClick={handleEye}
        >
          <EyeIcon visible={visible} />
        </button>
      </div>
    </div>
  );
}

export default PasswordField;
